import { useFormContext } from 'react-hook-form'
import OrderOptInFields from '../contact/opt-in-fields'
import OrderContactQuestionField from './contact-question-field'
import CheckboxField from 'modules/ui/molecules/FormComponents/CheckboxField'
import InputField from 'modules/ui/molecules/FormComponents/InputField'
import Label from 'modules/ui/atoms/Typography/Label'
import useConfig from 'modules/config/state/use-config'
import OrderAnonymousFields from '../contact/anonymous-fields'
import Column from 'modules/ui/atoms/Layout/Column'
import Row from 'modules/ui/atoms/Layout/Row'
import { useTranslation } from 'next-i18next'

const OrderContactQuestions1 = () => {
  const { t } = useTranslation()
  const config = useConfig()
  const form = useFormContext()

  const {
    watch,
    formState: { errors },
  } = form

  const watchIsCompanyCard = watch('isCompanyCard')

  const fieldError = (fieldName: string) =>
    form.formState.errors[fieldName] as { message: string } | undefined

  return (
    <Column>
      <Row>
        <OrderContactQuestionField fieldName="prefix" showRequired />
        <Column>
          <InputField
            required
            id="firstName"
            label={t('OrderContactQuestions1.firstName.label', 'First Name')}
            autoComplete="given-name"
            error={fieldError('firstName')}
            dataId="contact-first-name-input"
          />
        </Column>
      </Row>

      <Row>
        <OrderContactQuestionField fieldName="middle_name" showRequired />
        <Column>
          <InputField
            id="lastName"
            label={t('OrderContactQuestions1.lastName.label', 'Last Name')}
            autoComplete="family-name"
            error={fieldError('lastName')}
            required
            dataId="contact-last-name-input"
          />
        </Column>
      </Row>

      <Row>
        <OrderContactQuestionField fieldName="suffix" showRequired />
      </Row>

      {config.payment.corporateDonationEnabled && (
        <Row>
          <CheckboxField id="isCompanyCard" dataId="contact-is-company-card-checkbox">
            <Label size="sm">
              {t('OrderContactQuestions1.isCompanyCard.label', 'Donate as an organization')}
            </Label>
          </CheckboxField>
        </Row>
      )}

      {watchIsCompanyCard && (
        <Row>
          <Column>
            <InputField
              required
              id="cardCompanyName"
              label={t('OrderContactQuestions1.companyName.label', 'Company Name')}
              dataId="contact-card-company-name-input"
              error={errors.cardCompanyName as { message: string }}
              autoComplete="organization"
            />
          </Column>
        </Row>
      )}

      <OrderAnonymousFields />

      <InputField
        required
        id="email"
        type="email"
        label={t('OrderContactQuestions1.email.label', 'Email for receipt')}
        error={fieldError('email')}
        autoComplete="email"
        dataId="contact-email-input"
      />

      <OrderOptInFields />
    </Column>
  )
}

export default OrderContactQuestions1
